import React, { Component } from "react";
import Routes from "./Routes";
import fs from "bro-fs";
import p from  '../package.json';

fs.init({ type: window.TEMPORARY, bytes: 5 * 1024 * 1024 })
// .then(() => fs.clear())

console.log('App Name: ', p.name)
console.log('Version: ', p.version)
class App extends Component {
  render() {
    return <Routes />;
  }
}

export default App;
